import React from "react";
import { useSelector } from "react-redux";
import Landing from "../Landing";
import Verification from "../Verification";

const ProtectedRoute = (props) => {
  const blockchain = useSelector((state) => state.blockchain);
  return blockchain.account ? (
    <Landing myFunctions={props.myFunctions} />
  ) : (
    <Verification myFunctions={props.myFunctions} />
  );
};

export default ProtectedRoute;
